import gql from "graphql-tag";
const getImageJsonQuery = gql(` 
query getImageJson($data: AWSJSON!) {
  getImageJson(data: $data) {
    result
  }
}
`)
export default getImageJsonQuery
